import React from 'react';
import { Empty, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { JobDTO } from 'types/types';
import JobsDiff from './JobsDiff/JobsDiff';
import InformationTab from './InformationTab/informationTab';
import SpinnerChidori from 'components/SpinnerChidori/SpinnerChidori';
import './JobsCompare.scss';
import { useGetJobDetail } from 'hooks/jobs';

interface JobsCompareProps {
  jobs: JobDTO[];
}

const JobsCompare: React.FC<JobsCompareProps> = ({ jobs }) => {
  const { data: job1, isLoading: isLoadingJob1 } = useGetJobDetail({
    jobId: jobs[0].sparkJobId ?? '',
    isEnabled: !!jobs[0].sparkJobId,
  });
  const { data: job2, isLoading: isLoadingJob2 } = useGetJobDetail({
    jobId: jobs[1].sparkJobId ?? '',
    isEnabled: !!jobs[1].sparkJobId,
  });
  const jobCode1 = job1?.code;
  const jobCode2 = job2?.code;
  const jobProperties1 = job1?.properties;
  const jobProperties2 = job2?.properties;
  const errProperties1 = !job1?.properties;
  const errProperties2 = !job2?.properties;
  const errCode1 = !job1?.code;
  const errCode2 = !job2?.code;
  const onChange = (key: string) => {
    console.log(`Active tab: ${key}`);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Jobs Information',
      children: <InformationTab jobs={jobs} />,
    },
    {
      key: '2',
      label: 'Jobs Properties',
      children: (
        <div className="jobs-properties">
          {isLoadingJob1 || isLoadingJob2 ? (
            <div className="spinner-chidori">
              <SpinnerChidori />
            </div>
          ) : errProperties1 || errProperties2 ? (
            <div className="jobs-error">
              <Empty description="No Data Available" />
            </div>
          ) : jobProperties1 && jobProperties2 ? (
            <JobsDiff
              jobs={jobs}
              oldCode={jobProperties1}
              newCode={jobProperties2}
            />
          ) : (
            <div className="spinner-chidori">
              <SpinnerChidori />
            </div>
          )}
        </div>
      ),
    },
    {
      key: '3',
      label: 'Jobs Code',
      children: (
        <div className="jobs-code">
          {isLoadingJob1 || isLoadingJob2 ? (
            <div className="spinner-chidori">
              <SpinnerChidori />
            </div>
          ) : errCode1 || errCode2 ? (
            <div className="jobs-error">
              <Empty description="No Data Available" />
            </div>
          ) : jobCode1 && jobCode2 ? (
            <JobsDiff jobs={jobs} oldCode={jobCode1} newCode={jobCode2} />
          ) : (
            <div className="spinner-chidori">
              <SpinnerChidori />
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="jobs-compare">
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </div>
  );
};

export default JobsCompare;
